module.exports = __webpack_public_path__ + "665efcf2f67f1849557342890c75fae4.svg";